export default function ActiveIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      id="Regular"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      {/* <circle cx="4" cy="4" r="4" fill="currentColor" /> */}
      <circle cx="24" cy="24" r="10" fill="currentColor" />
    </svg>
  );
}
